import { render, staticRenderFns } from "./ListOccurrences.vue?vue&type=template&id=a173c66e"
import script from "./ListOccurrences.vue?vue&type=script&lang=js"
export * from "./ListOccurrences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports